module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov6-5c5b74e084e3e1f1d6807b2c7ff69b8d.jpg";